module.exports = __webpack_public_path__ + "static/media/RI.6c11e7e0.png";